<template lang="pug">
div(
    class="icon"
)
        img(
            v-if="iconSrc"
            class="svg"
            :src="iconSrc"
        )
        div(
            v-else
            class="icon"
        )
            i(:class="iconName")
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
    iconSrc?: string
    iconName?: string
    size?: number
    color?: string
}>(), {
    size: 30,
    color: '',
})

const iconSize = computed<string>(() => `${props.size}px`)
const fontIconSize = computed<string>(() => `${props.size * 0.5}px`)
</script>

<style lang="sass" scoped>
.icon
    @extend %size
    background: v-bind(color)
    display: flex
    border-radius: var(--tl-radius-sm)
    align-items: center
    justify-content: center
    i
        font-size: v-bind(fontIconSize)
.svg
    @extend %size
    display: block

%size
    width: v-bind(iconSize)
    height: v-bind(iconSize)
</style>
